import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Check } from "lucide-react";

export default function FeedbackTab({ onReload }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/feedback");
      setRows(r.data);
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const resolve = async (r) => {
    try {
      await api.put(`/admin/feedback/${r.id}/resolve`);
      toast.success("Ditandai selesai");
      load();
      onReload && onReload();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    }
  };

  return (
    <div className="space-y-4" data-testid="feedback-tab">
      <div className="border border-stone-200 bg-white overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead className="bg-stone-50 text-left">
            <tr>
              <th className="px-4 py-3 overline text-stone-500">Nama</th>
              <th className="px-4 py-3 overline text-stone-500">Kategori</th>
              <th className="px-4 py-3 overline text-stone-500">Kontak</th>
              <th className="px-4 py-3 overline text-stone-500">Pesan</th>
              <th className="px-4 py-3 overline text-stone-500">Status</th>
              <th className="px-4 py-3 overline text-stone-500">Tanggal</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-stone-500">Memuat…</td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={7} className="px-4 py-10 text-center text-stone-500">Belum ada masukan.</td></tr>
            ) : rows.map((r) => (
              <tr key={r.id} className={`border-t border-stone-200 ${r.resolved ? "opacity-60" : ""}`} data-testid={`feedback-row-${r.id}`}>
                <td className="px-4 py-3 font-medium">{r.name}</td>
                <td className="px-4 py-3 capitalize">{r.category}</td>
                <td className="px-4 py-3 text-stone-500 text-xs">
                  {r.email && <div>{r.email}</div>}
                  {r.whatsapp && <div>{r.whatsapp}</div>}
                </td>
                <td className="px-4 py-3 max-w-md">{r.message}</td>
                <td className="px-4 py-3">
                  {r.resolved ? (
                    <span className="text-xs px-2 py-1 bg-green-100 text-green-700">Selesai</span>
                  ) : (
                    <span className="text-xs px-2 py-1 bg-orange-100 text-[#F39237]">Baru</span>
                  )}
                </td>
                <td className="px-4 py-3 text-xs text-stone-500 whitespace-nowrap">
                  {new Date(r.created_at).toLocaleDateString("id-ID")}
                </td>
                <td className="px-4 py-3">
                  {!r.resolved && (
                    <button
                      onClick={() => resolve(r)}
                      data-testid={`resolve-${r.id}`}
                      className="p-2 text-stone-600 hover:text-[#F39237]"
                      title="Tandai selesai"
                    >
                      <Check size={14} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
